import { useEffect, useRef, useState } from "react";
import TrimbleMaps from "@trimblemaps/trimblemaps-js";
import { Select, Row, Typography, Card } from 'antd';
import StopsTable from "./StopsTable";
import { ShrinkOutlined, ArrowsAltOutlined } from "@ant-design/icons";

const apiKey = "C40FE2EBEAE09F4AA3C53FABCB3BDBB0";

const TollDetailReport = () => {
  const mapContainerRef = useRef(null); // Ref for the map container
  const [stops, setStops] = useState([]);
  const [data, setData] = useState([]);
  const [addedStops, setAddedStops] = useState([]);
  const [currentValue, setCurrentValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);

  let timeout;

  const onGetRouteReports = () => {
    setIsLoading(true);
    const requestData = {
      "ReportRoutes": [
        {
          "ReportingOptions": {
            "RouteCosts": {
              "FuelEconomyLoaded": 6.96,
              "FuelEconomyEmpty": 0,
              "PricePerFuelUnit": 4.02,
              "GreenHouseGas": 22.4,
              "OtherCostPerDistUnitLoaded": 0.22,
              "OtherCostPerDistanceUnitEmpty": 0,
              "CostTimeLoaded": 47.89,
              "CostTimeEmpty": 0
            },
            "IncludeFerryDistance": true,
            "FuelUnits": 0,
            "UseTollData": true,
            "TollCurrency": 0,
            "ExchangeRate": 1.355,
            "TollDiscount": "",
            "UseTraffic": false
          },
          "ReportTypes": [
            {
              "__type": "MileageReportType:http://pcmiler.alk.com/APIs/v1.0",
              "THoursWithSeconds": false
            },
            {
              "__type": "DirectionsReportType:http://pcmiler.alk.com/APIs/v1.0",
              "CondenseDirections": false
            }
          ],
          "RouteId": "1",
          "Stops": addedStops,
          "Options": {
            "VehicleType": 0,
            "RoutingType": 0,
            "HubRouting": false,
            "TollDiscourage": false,
            "TollRoads": 3,
            "AFSetIDs": [],
            "BordersOpen": true,
            "HighwayOnly": false,
            "HazMatType": 0,
            "DistanceUnits": 0,
            "TruckCfg": {
              "LCV": false,
              "Units": 0,
              "Height": "13'6\"",
              "Length": "48'0\"",
              "Width": "96\"",
              "Weight": 80000,
              "Axles": 5,
              "MaxWeightPerAxleGroup": 34000
            },
            "FerryDiscourage": false,
            "SideOfStreetAdherence": 0,
            "UseAvoidsAndFavors": false,
            "UseSites": true,
            "IncludeTrimblePlaceIDs": true,
            "ClassOverrides": 0
          }
        }
      ]
    };

    fetch(`https://pcmiler.alk.com/apis/rest/v1.0/Service.svc/route/routeReports?dataVersion=current&authToken=${apiKey}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
    })
      .then(response => response.json())
      .then(data => {
        setIsLoading(false);
        const reportData = data[0].ReportLines;
        const resultArray = addedStops.map((addedStop, index) => ({
          ...addedStop,
          LHours: reportData[index].LHours,
          LMiles: reportData[index].LMiles,
          LTolls: reportData[index].LTolls,
          LCostMile: reportData[index].LCostMile,
          TCostMile: reportData[index].TCostMile,
          THours: reportData[index].THours,
          TMiles: reportData[index].TMiles,
          TTolls: reportData[index].TTolls,
        }));
        setAddedStops(resultArray);
      })
      .catch(error => console.error('Error:', error));
  };

  const fetchData = (value, callback) => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }

    const searchAddress = () => {
      fetch(`https://singlesearch.alk.com/na/api/search/?authToken=${apiKey}&countryType=FIPS&maxResults=10&query=${value}&useCustomPlaces=true`)
        .then(response => response.json())
        .then((result) => {
          if (result.Err == 0) {
            const data = result.Locations.map((item, index) => {
              const { StreetAddress, City, State, Zip } = item.Address;

              // Create the address string based on available data
              let addressText = "";

              if (StreetAddress) {
                addressText = `${StreetAddress}, ${City}, ${State} ${Zip}`;
              } else {
                // If no StreetAddress, just use City, State, and Zip
                addressText = `${City}, ${State} ${Zip}`;
              }

              // Return a new object with the address text and other data
              return {
                ...item,
                value: index,
                text: addressText.trim() // trim to avoid extra spaces
              };
            });
            callback(data);
          }
        });
    };
    if (value) {
      timeout = setTimeout(searchAddress, 300);
    } else {
      callback([]);
    }
  };

  const handleSearch = (newValue) => {
    fetchData(newValue, setData);
  };

  const handleSelect = (newValue) => {
    setCurrentValue(newValue);
    setStops([
      ...stops,
      new TrimbleMaps.LngLat(data[newValue].Coords.Lon, data[newValue].Coords.Lat)
    ]);
    setAddedStops([
      ...addedStops,
      {
        ...data[newValue],
        value: newValue,
        text: data[newValue].text
      }
    ]);
  };

  const handleUpdateStops = (type, value) => {
    const stops_ = stops;
    const addedStops_ = addedStops;

    if (type === "remove") {
      setStops(stops_.filter((_, index) => index !== value));
      setAddedStops(addedStops_.filter((_, index) => index !== value));
    }

    if (type === "up") {
      setStops(prevStops => {
        if (prevStops.length < value) return prevStops; // Ensure there are at least 4 items

        const newStops = [...prevStops]; // Create a shallow copy of the array
        [newStops[value - 1], newStops[value]] = [newStops[value], newStops[value - 1]]; // Swap 3rd and 4th items

        return newStops; // Return the updated array
      });
      setAddedStops(prevAddedStops => {
        if (prevAddedStops.length < value) return prevAddedStops; // Ensure there are at least 4 items

        const newAddedStops = [...prevAddedStops]; // Create a shallow copy of the array
        [newAddedStops[value - 1], newAddedStops[value]] = [newAddedStops[value], newAddedStops[value - 1]]; // Swap 3rd and 4th items

        return newAddedStops; // Return the updated array
      });
    }

    if (type === "down") {
      setStops(prevStops => {
        if (prevStops.length < value) return prevStops; // Ensure there are at least 4 items

        const newStops = [...prevStops]; // Create a shallow copy of the array
        [newStops[value], newStops[value + 1]] = [newStops[value + 1], newStops[value]]; // Swap 3rd and 4th items

        return newStops; // Return the updated array
      });
      setAddedStops(prevAddedStops => {
        if (prevAddedStops.length < value) return prevAddedStops; // Ensure there are at least 4 items

        const newAddedStops = [...prevAddedStops]; // Create a shallow copy of the array
        [newAddedStops[value], newAddedStops[value + 1]] = [newAddedStops[value + 1], newAddedStops[value]]; // Swap 3rd and 4th items

        return newAddedStops; // Return the updated array
      });
    }
  }

  useEffect(() => {
    // Ensure the TrimbleMaps API is loaded
    if (!TrimbleMaps) return;

    if (stops.length > 1) {
      onGetRouteReports();
    }

    // Set the API key for TrimbleMaps
    TrimbleMaps.APIKey = apiKey;

    // Initialize the map with options (only happens once)
    const map = new TrimbleMaps.Map({
      container: mapContainerRef.current, // Use the ref to get the map container
      style: TrimbleMaps.Common.Style.TRANSPORTATION,
      center: stops[stops.length - 1] || new TrimbleMaps.LngLat(-74.566234, 40.49944), // Initial map center
      zoom: 8, // Initial zoom level
    });

    // Create a new route with stop locations
    const myRoute = new TrimbleMaps.Route({
      routeId: "myRoute",
      stops: stops,
    });

    // Add route to map once map is loaded
    map.on("load", function () {
      myRoute.addTo(map);
    });

    // Cleanup map on unmount
    return () => {
      map.remove();
    };
  }, [stops]);

  return (
    <>
      <div
        ref={mapContainerRef} // Assign ref to the map container
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          width: "100%",
          height: "100vh", // Ensure the map takes up full screen height
        }}
      ></div>
      <Card className="stops-card">
        <div className="animated-container">
          <Row className="row-settings header-icons">
            {!isExpanded ? (
              <ArrowsAltOutlined className="down-icon" onClick={() => setIsExpanded(true)} />
            ) : (
              <ShrinkOutlined className="up-icon" onClick={() => setIsExpanded(false)} />
            )}
          </Row>
          <Row className="card-header-row">
            <Typography className="t-title">Add Stop</Typography>
            <Select
              showSearch
              placeholder={"Search for Address or Place"}
              defaultActiveFirstOption={false}
              suffixIcon={null}
              filterOption={false}
              onSearch={handleSearch}
              onSelect={handleSelect}
              value={currentValue}
              notFoundContent={null}
              options={(data || []).map(d => ({
                value: d.value,
                label: d.text,
                key: d.value
              }))}
              className="search-input-form"
            />
          </Row>
          <Row className={`card-content ${isExpanded ? "open" : "closed"}`}>
            <StopsTable addedStops={addedStops} handleUpdateStops={handleUpdateStops} isLoading={isLoading} />
          </Row>
        </div>
      </Card>
    </>
  );
};

export default TollDetailReport;
